module.exports = __webpack_public_path__ + "static/media/roo_wor_net_bea_bag.08c4c459.png";